module.exports = "<div class=form-control> {{#if unvisible}} <a href=javascript:void(0); class=info>权限受限</a> {{else if be_control_condition }} <a href=javascript:void(0); class=info>被修改条件限制</a> {{else}} <div class=dropdown></div> <div class=form-print-icon> {{#if required}} <span id=requiredLogo class={{requiredClass}}></span> {{/if}} </div> {{/if}} </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/year-control/year-control.html
// module id = 1953
// module chunks = 50